export default __webpack_public_path__ + "static/media/magic_sms.11cd7dbf.svg";